
import {  appConst, Component, FormModalMixins } from "@/lib";
import IncomeDetail from "@/store/modules/foreignexchangecollection/incomedetail/entity"

@Component
export default class CreateIncomeDetailModel extends FormModalMixins {
  model:IncomeDetail = new IncomeDetail();

  get record(){
    return this.$store.state.foreignexchangecollection.income.editDetail as IncomeDetail;
  }

  created() {
    Object.assign(this.config,{
        labelWidth: 100,
        width: 700
    })
  }

  get modelTitleL() {
    return this.model.editRowIndex > -1 ? "app.IncomeDetail.Edit" : "app.IncomeDetail.Add";
  }

  get incomeTypeList() {
    return this.getCodeListByCategory(appConst.codeCategory.incomeType);
  }

  get rules() {
    return {
      amount: [
        {
          type: "number",
          required: true, //是否必填
          message: this.L("Validate.PleaseInput", this.L('app.IncomeDetail.Amount')), //验证信息
          trigger: "blur", //触发方式    常用  blur 和 change}
        }
      ]
    }
  }

  amountChange() {
    if (!this.model.incomeType || !!this.model.bankFee || !this.model.amount) {
      return;
    }
    if (this.model.incomeType === appConst.incomeType.prepayment) {
      if (!!this.model.prePaymentAmount) {
        this.model.bankFee = Number.parseFloat((this.model.prePaymentAmount - this.model.amount).toFixed(2));
      }
      
    } else if (this.model.incomeType === appConst.incomeType.restAmount) {
      if (!!this.model.restAmount) {
        this.model.bankFee = Number.parseFloat((this.model.restAmount - this.model.amount).toFixed(2));
      }
    }
    if (this.model.bankFee < 0) {
      this.model.bankFee = 0;
    }
  }

  close() {
    this.config.isShow = false;
    this.model = new IncomeDetail();
  }
}

